import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer__social">
				<ul className="footer__list">
					<li className="footer__item">
						<a href="https://twitter.com/Byte_Mee">
							<FontAwesomeIcon
								icon={['fab', 'twitter']}
								size="5x"
							/>
						</a>
					</li>
					<li className="footer__item">
						<a href="https://github.com/SheW0lf">
							<FontAwesomeIcon
								icon={['fab', 'github-alt']}
								size="5x"
							/>
						</a>
					</li>
					<li className="footer__item">
						<a href="https://codepen.io/SheWolf/">
							<FontAwesomeIcon
								icon={['fab', 'codepen']}
								size="5x"
							/>
						</a>
					</li>
				</ul>
			</div>
			<p className="footer__copyright">
				Made with &nbsp;
				<FontAwesomeIcon
					icon={['fas', 'heart']}
					className="footer__heart"
				/>
				&nbsp; | Copyright &copy; {new Date().getFullYear()}
			</p>
		</footer>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js